import "./StateReportingListTableComponent.scss";
import {ITableColumn} from "../../../shared/models/table.model";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import React, {useCallback} from "react";
import {CommonService} from "../../../shared/services";
import {APIConfig} from "../../../constants";
import TableWrapperV2Component
    from "../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import {Link} from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {ISample} from "../../../shared/models/sample.model";
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import commonService from "../../../shared/services/common.service";
import TooltipComponent from "../../../shared/components/tooltip/tooltipComponent";

interface StateReportingListTableComponentProps {
    filterData?: {};
}

const StateReportingListTableComponent = (props: StateReportingListTableComponentProps) => {

    const {filterData} = props;
    const columns: ITableColumn[] = [
        {id: 'id', label: 'Session ID', isDefaultColumn: true, sortable: false,fixed:"left",width:"120",align:'center'},
        {id: 'testName', label: 'Test Name', isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {
                        (item?.testName).length > 23 ?
                            <TooltipComponent
                                tooltip={CommonService.capitalizeFirstLetterOfEachWord(item?.testName)}
                                placement={"top"}
                                arrow={true}
                            >
                                <div className={"ellipses-for-table-data"}>
                                    {CommonService.capitalizeFirstLetterOfEachWord(item?.testName)}
                                </div>
                            </TooltipComponent> :
                            <>
                                {CommonService.capitalizeFirstLetterOfEachWord(item?.testName)}
                            </>
                    }
                </>
            )
        },
        {
            id: 'reportingTime', label: 'Report Date & Time',align:'center',
            isDefaultColumn: true,
            content: (item: any) => (
                <>
                    {
                        item.reportingTime ?
                            <>
                                {commonService.formatDate(item?.reportingTime)}
                                &nbsp;|&nbsp;
                                {commonService.formatTime(item?.reportingTime)} <br/>
                            </> : <> - </>
                    }
                </>

            )
        },
        {id: 'sampleCount', label: 'Test Samples', sortable: false, isDefaultColumn: true,align:'center'},
        {
            id: 'status', label: 'Status', isDefaultColumn: true,width:'150',align:'center',
            content: (item: ISample) => (
                <ChipComponent className={`min-width-80 ${item?.status}`}
                               label={CommonService.capitalizeFirstLetter(item?.status)}
                               variant={'outlined'}/>
            )
        },
        {
            id: 'download', label: '', sortable: false, isDefaultColumn: true,align:'center',
            content: (item: any) => (
                <ButtonComponent
                    color={'primary'}
                    variant={'outlined'}
                    size={'small'}
                    startIcon={<ArrowDownwardIcon/>}
                    handleClick={() => {
                        downloadResultCSV(item.attachment)
                    }}
                >Download CSV</ButtonComponent>
            )
        },
        {
            id: 'actions',
            label: '',
            isDefaultColumn: true,
            width:"80",
            align:'center',
            hideInColumnPreferences: true,
            fixed:"right",
            content: (item: any, index: any) => (
                <React.Fragment>
                    <div className="table-actions" id={`view_testPanel_` + index}>
                        <Link to={CommonService._routeConfig.StateReportingViewRoute(item?.id)}>
                            <div className="table-action">
                                <ChevronRightIcon/>
                            </div>
                        </Link>
                    </div>
                </React.Fragment>
            )
        },
    ];

    const downloadResultCSV = useCallback((attachmentDetails: any) => {
        CommonService.downloadFile(attachmentDetails.url, attachmentDetails.title || 'result.xlsx', 'csv')
    }, []);

    return (
        <div className={'table-list-container'}>
            <TableWrapperV2Component
                isPaginated={true}
                columns={columns}
                url={APIConfig.STATE_REPORTING_LIST.URL}
                method={APIConfig.STATE_REPORTING_LIST.METHOD}
                extraPayload={filterData}
                isColumnFilterVisible={true}
            />
        </div>
    );

};

export default StateReportingListTableComponent;
